import React, {useState, useEffect, useRef} from 'react';
import Stepper from 'react-stepper-horizontal';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Select from 'react-select';
import {Form} from 'react-bootstrap';
import * as AuthService from '../../../services/auth';
import {useStateWithCallbackLazy} from 'use-state-with-callback';
import {PfImage} from '@profabric/react-components';
import styled from 'styled-components';
import {logoutUser} from '@store/reducers/auth';
import {useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import Card from 'react-bootstrap/Card';
import {QRCodeSVG} from 'qrcode.react';
import {useReactToPrint} from 'react-to-print';
import {textDecoration} from '@chakra-ui/system';
export default function ModalTicket(props) {
  useEffect(() => {
    if (Object.keys(props.dropdowns).length !== 0) {
      console.log(props.dropdowns);
      setDropdownCostcenter(props.dropdowns.COSTCENTER);
      setDropdownCompany(props.dropdowns.COMPANY);
      setDropdownCarPublic(props.dropdowns.CAR_PUBLIC);
      setDropdownCar(props.dropdowns.CAR_MY);
    }
  }, [props.dropdowns]);

  useEffect(() => {
    console.log('CHANGE');
    if (props.item) {
      downloadExpendWs(props.item.planid);
      downloadPathWs(props.item.planid);
      setDropdownApvPlan(props.item.apvPlanid);
      setDropdownApvActual(props.item.apvActualid);
      downloadPlaceWs(props.item.planid);
      setPlan((prevState) => ({
        ...prevState,
        vehicleid: props.item.vehicleid
      }));
    }
  }, [props.item]);

  const StyledUserImage = styled(PfImage)``;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const downloadExpendWs = async (planid) => {
    try {
      const expends = await AuthService.downloadExpendCar(planid);
      console.log(expends);
      if (expends.error) throw 'timeout';

      setDropdownExpend(expends.EXPEND);
    } catch (error) {
      console.log('exit expend');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };
  const downloadPlaceWs = async (planid) => {
    try {
      const places = await AuthService.downloadPlace(planid, 'plan');
      if (places.error) throw 'timeout';
      if (places.filter((e) => e.type === 'plan').length === 1)
        setPlaces(places.filter((e) => e.type === 'plan')[0].places);
    } catch (error) {
      console.log('exit place');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };

  const componentRef = useRef(null);
  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  });

  const downloadPathWs = async (planid) => {
    try {
      const path = await AuthService.downloadPath(planid);
      if (path.error) throw 'timeout';
      setApprovePath(
        path.map((e, i) => {
          return {
            ...e,
            href: '#',
            onClick: (e) => {
              e.preventDefault();
            }
          };
        })
      );
    } catch (error) {
      console.log('exit path');
      props.onHide();
      dispatch(logoutUser());
      // navigate('/login');
      window.location.href = '/login';
    }
  };
  const [key, setKey] = useState('plan');
  const [dropdownCar, setDropdownCar] = useState({DATA: []});
  const [dropdownCarPublic, setDropdownCarPublic] = useState({DATA: []});
  const [plan, setPlan] = useState({
    vehicleid: {value: '', label: 'เลือกยานพาหนะ'}
  });
  const [places, setPlaces] = useState([]);
  const [approvePath, setApprovePath] = useState([]);
  const [dropdownCompany, setDropdownCompany] = useState({DATA: []});
  const [dropdownCostcenter, setDropdownCostcenter] = useState({DATA: []});
  const [dropdownExpend, setDropdownExpend] = useStateWithCallbackLazy([]);
  const [dropdownApvPlan, setDropdownApvPlan] = useState({});
  const [dropdownApvActual, setDropdownApvActual] = useState({});

  return (
    <div className="row">
      <div className="col-12 col-md-9">
        {/* <Card className="bg-light">
          <Stepper
            activeColor={
              approvePath.filter((e) => e.statue === 'reject').length >= 1
                ? '#bb392d'
                : '#42997f'
            }
            titleFontSize={12}
            circleFontSize={12}
            steps={approvePath}
            activeStep={
              approvePath.filter((e) => e.statue === 'approve').length ===
              approvePath.length
                ? approvePath.length - 1
                : approvePath.filter((e) => e.statue === 'approve').length
            }
          />
        </Card> */}
        <div className="col-12 d-flex justify-content-end">
          <a>
            <i className="fas fa-print" onClick={handlePrint} style={{cursor : "pointer"}}/>
          </a>
        </div>
        <Tabs
          id="controlled-tab-example"
          activeKey={key}
          onSelect={(k) => setKey(k)}
          className="mb-3"
        >
          <Tab eventKey="plan" title="ข้อมูล">
            <div className="row" style={{padding: 40}} ref={componentRef}>
              <div className="row col-12">
                <div>
                  <img src="https://api-passport.advanceagro.net/img/doubleA.jpg"></img>
                </div>
                <div className="col-10">
                  1 หมู่ 2 ต.ท่าตูม อ.ศรีมหาโพธิ จ.ปราจีนบุรี 25140
                  <br />
                  94/1 หมู่ 3 ต.เขาหินซ้อน อ.พนมสารคาม จ.ฉะเชิงเทรา 24120
                  <br />
                  187/3 หมู่ 1 ถ.บางนา-ตราด กม.42 ต.บางวัว อ.บางปะกง
                  จ.ฉะเชิงเทรา 24180
                  <br />
                </div>
              </div>
              <div className="col-12">
                <hr />
              </div>
              <div
                className="col-12 text-center font-weight-bold mb-3"
                style={{textDecoration: 'underline'}}
              >
                <h5>ใบแจ้งหนี้</h5>
              </div>
              {/* <div className="col-12">
                <hr />
              </div> */}
              <div className="row col-9">
                <Form.Group className="mb-3 col-4">
                  <Form.Label>พนักงาน</Form.Label>
                  <Form.Control
                    type="text"
                    value={props.item ? props.item.staff : ''}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="mb-3 col-4">
                  <Form.Label>ประเภทการเดินทาง</Form.Label>
                  <Form.Control
                    type="text"
                    value={props.item ? props.item.typeid.label : ''}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="mb-3 col-4">
                  <Form.Label>เลือกรถ</Form.Label>
                  <Select
                    isDisabled={
                      props.item
                        ? props.item.status === 'reject' &&
                          props.item.rejectNumber === 1
                          ? false
                          : props.mode === 'read'
                        : true
                    }
                    value={plan.vehicleid}
                    options={
                      props.item
                        ? props.item.typeid.value === '1'
                          ? dropdownCar.DATA
                          : dropdownCarPublic.DATA
                        : []
                    }
                    onChange={(v) => {
                      setPlan((prevState) => ({
                        ...prevState,
                        vehicleid: v
                      }));
                    }}
                  />
                </Form.Group>
                <Form.Group className="mb-3 col-4">
                  <Form.Label>วันเวลาที่เดินทางไป</Form.Label>
                  <Form.Control
                    type="text"
                    value={props.item ? props.item.date_start : ''}
                    disabled
                  />
                </Form.Group>
                <Form.Group
                  className={
                    props.item
                      ? props.item.typeid.value === '1'
                        ? 'mb-3 col-4 d-none'
                        : 'mb-3 col-4'
                      : 'mb-3 col-md-4'
                  }
                >
                  <Form.Label>วันเวลาที่เดินทางกลับ</Form.Label>
                  <Form.Control
                    type="text"
                    value={props.item ? props.item.date_stop : ''}
                    disabled
                  />
                </Form.Group>
                <Form.Group className="mb-3 col-12">
                  <Form.Control
                    as="textarea"
                    rows={1}
                    disabled
                    value={props.item ? props.item.objective : ''}
                    placeholder="วัตถุประสงค์"
                  />
                </Form.Group>
              </div>
              <div className="col-3 text-center">
                {props.item ? (
                  props.item.typeid.value === '1' ? (
                    <>
                      {props.item.planid}
                      <img
                        className="car-img2"
                        src={props.item ? props.item.vehicleid.image : ''}
                      ></img>
                    </>
                  ) : (
                    <>
                      {props.item.planid}
                      <QRCodeSVG
                        value={props.item ? props.item.planid : 'nodata'}
                        size={160}
                      />
                    </>
                  )
                ) : (
                  <></>
                )}
                <div className="mb-0">
                  {props.item ? props.item.date_start : ''}
                </div>
              </div>

              <Form.Group className="mb-3 col-6">
                <Select
                  isDisabled={props.mode === 'read'}
                  placeholder={'บริษัทรับทราบค่าใช้จ่าย'}
                  value={props.item ? props.item.companyid : {}}
                  options={dropdownCompany.DATA}
                  onChange={(v) => {}}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-6">
                <Select
                  isDisabled={props.mode === 'read'}
                  value={props.item ? props.item.costid : {}}
                  placeholder={'cost center'}
                  options={
                    !props.item
                      ? dropdownCostcenter.DATA
                      : dropdownCostcenter.DATA.filter(
                          (e) => e.company === props.item.companyid.value
                        )
                  }
                  onChange={(v) => {}}
                />
              </Form.Group>
              {/* <Form.Group className="mb-3 col-md-6">
                <Select
                  isDisabled={true}
                  value={dropdownApvPlan}
                  placeholder={'เลือกผู้อนุมัติแผน'}
                  options={[]}
                  formatOptionLabel={(e) => (
                    <div className="d-flex">
                      <StyledUserImage
                        src={e.image}
                        fallbackSrc="/img/default-profile.png"
                        width={34}
                        height={34}
                        rounded
                      />
                      <span className="align-self-center ml-2">{e.label}</span>
                    </div>
                  )}
                />
              </Form.Group> */}
              {/* <Form.Group className="mb-3 col-md-6">
                <Select
                  isDisabled={true}
                  value={dropdownApvActual}
                  placeholder={'เลือกผู้อนุมัติผล'}
                  options={[]}
                  formatOptionLabel={(e) => (
                    <div className="d-flex">
                      <StyledUserImage
                        src={e.image}
                        fallbackSrc="/img/default-profile.png"
                        width={34}
                        height={34}
                        rounded
                      />
                      <span className="align-self-center ml-2">{e.label}</span>
                    </div>
                  )}
                />
              </Form.Group> */}
              {/* <Form.Group className="mb-3 col-md-10">
                <Select
                  isMulti
                  isDisabled={true}
                  value={dropdownExpend}
                  menuPlacement="top"
                  className="basic-multi-select"
                  classNamePrefix="select"
                  placeholder={'ค่าใช้จ่ายอื่นๆ'}
                  options={[]}
                />
              </Form.Group>
              <Form.Group className="mb-3 col-md-2">
                <Form.Control
                  type="number"
                  placeholder="(บาท)"
                  disabled
                  value={props.item ? props.item.totalExpend : 0}
                />
              </Form.Group> */}
              {/* <Form.Group className="mb-3 col-md-5">
                <SelectedBox isDisabled={true} selected={dropdownExpend} />
              </Form.Group> */}
              <div className="col-6 mb-2">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">คอย | ไม่คอย</span>
                  </div>
                  <input type="text" className="form-control" value={''} />
                </div>
              </div>
              <div className="col-6 mb-2">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">ยี่ห้อ | ทะเบียน</span>
                  </div>
                  <input type="text" className="form-control" value={''} />
                </div>
              </div>
              <div className="col-6 mb-2">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">ชื่อ | เบอร์คนขับ</span>
                  </div>
                  <input type="text" className="form-control" value={''} />
                </div>
              </div>
              <div className="col-6 mb-2">
                <div className="input-group">
                  <div className="input-group-prepend">
                    <span className="input-group-text">
                      เลขไมล์เริ่ม | สิ้นสุด
                    </span>
                  </div>
                  <input type="text" className="form-control" value={''} />
                </div>
              </div>
              <div className="col-12">
                <hr />
              </div>
              {places.map((e, i) => {
                return (
                  <div className="row col-12">
                    <div className="p-2 col-2 text-center">
                      <QRCodeSVG
                        value={`http://www.google.com/maps/place/${e.lat},${e.lng}`}
                        size={80}
                      />
                    </div>
                    <div className="col-10">
                      <Card className="card card-secondary" bg={'light'}>
                        <Card.Header className="text-center">
                          จุดที่ {i + 1}
                        </Card.Header>
                        <Card.Body style={{fontSize: 12}}>{e.name}</Card.Body>
                      </Card>
                    </div>
                  </div>
                );
              })}
              <div className="col-12">
                <table className="table table-bordered">
                  <thead>
                    <tr style={{textAlign: 'center', background: '#F5F5F5'}}>
                      <th scope="col" style={{width: '12.5%'}}>
                        ระยะที่วิ่ง (กม.)
                      </th>
                      <th scope="col" style={{width: '12.5%'}}>
                        ค่ากม.ที่วิ่ง (บาท)
                      </th>
                      <th scope="col" style={{width: '12.5%'}}>
                        ค่ารอคอย (บาท)
                      </th>
                      <th scope="col" style={{width: '12.5%'}}>
                        ค่าค้างคืน (บาท)
                      </th>
                      <th scope="col" style={{width: '12.5%'}}>
                        ค่าบรรทุก (บาท)
                      </th>
                      <th scope="col" style={{width: '12.5%'}}>
                        ค่าทางด่วน (บาท)
                      </th>
                      <th scope="col" style={{width: '12.5%'}}>
                        อื่นๆ (บาท)
                      </th>
                      <th scope="col" style={{width: '12.5%'}}>
                        รวม (บาท)
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <th scope="row">&nbsp;</th>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                      <td>&nbsp;</td>
                    </tr>
                    <tr style={{textAlign: 'center', background: '#F5F5F5'}}>
                      <th colSpan={8}>{`ระยะทางทั้งหมด ${
                        props.item
                          ? (props.item.distance / 1000).toFixed(2)
                          : '0'
                      } กิโลเมตร, จํานวนชั่วโมงที่ใช้ ..................... ชั่วโมง`}</th>
                    </tr>
                    <tr>
                      <td
                        style={{whiteSpace: 'pre-line'}}
                        colSpan={4}
                        rowSpan={2}
                      >
                        {`ขอรับรองว่า ข้อมูลทั้งหมดที่ปรากฎใน ใบวิ่งงาน/ใบแจ้งหนี้ นี้เป็นข้อมูลที่ถูกต้องทุกประการ \nหมายเหตุอื่นๆ (ถ้ามี):\n
                      ${
                        approvePath.length >= 1 ? approvePath[1].title : 'n/a'
                      }\n${
                          approvePath.length >= 1 ? approvePath[1].date : 'n/a'
                        }`}
                      </td>
                      <td
                        style={{whiteSpace: 'pre-line', textAlign: 'center'}}
                        colSpan={2}
                      >{`\n..............................................\n\n............../............../..............`}</td>
                      <td
                        style={{whiteSpace: 'pre-line', textAlign: 'center'}}
                        colSpan={2}
                      >{`\n..............................................\n\n............../............../..............`}</td>
                    </tr>
                    <tr>
                      <td
                        colSpan={2}
                        style={{textAlign: 'center', background: '#F5F5F5'}}
                      >
                        พนักงานขับรถ
                      </td>
                      <td
                        colSpan={2}
                        style={{textAlign: 'center', background: '#F5F5F5'}}
                      >
                        ผู้ขอใช้รถบริการ
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </Tab>
        </Tabs>
      </div>
    </div>
  );
}
